import { Component, TemplateRef, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Observable } from 'rxjs';
import { AuthService } from 'src/app/services/auth.service';
import { ClientsService } from 'src/app/services/clients.service';

@Component({
    selector: 'app-client-content',
    templateUrl: './client-content.component.html',
    styleUrl: './client-content.component.scss',
    standalone: false
})
export class ClientContentComponent {
	@ViewChild('successModal') successModal!: TemplateRef<any>;
	@ViewChild('updateClientStatusModal') updateClientStatusModal!: TemplateRef<any>;

	updateClientStatusModalRef: any;

	overview = '';
	currentClient!: any;
	clientObserve!: Observable<any>;
	clients: any[] = [];
	currentClientID!: number;
	currenttab = 1;
	editMode = false;
	modalType = '';

	submitted = false;
	spinner = false;
	success = false;
	error = false;
	message = '';
	selectedStatus = '';

	successMessage = '';

	projectListWidgets!: any;
	teamOverviewList: any;
	report_templates: any[] = [];

	constructor(private clientsService: ClientsService, private modalService: NgbModal, private route: ActivatedRoute, public authService: AuthService, private router: Router) {
		this.clientObserve = this.clientsService.client$;
		this.report_templates = clientsService.templatesList;

		this.clientObserve.subscribe((client: any) => {
      this.currentClient = client;
    });

		this.route.params.subscribe((params: any) => {
			this.currentClientID = Number(params.clientid);
			this.currentClient = this.clientsService.getClient();

			if (this.currentClient) {
				if (this.currentClientID !== this.currentClient.id) {
					this.setCurrentClient();
				}
			} else {
				this.setCurrentClient();
			}
			this.route.queryParams.subscribe((queryParams: any) => {
				this.currenttab = this.returnCurrentTab(queryParams.tab);
			})
		})
	}

	ngOnInit(): void {
		// this.isOwner = this.authService.currentClientValue.roles.includes('OWNER') || false;
	}

	toggleSidebar(event: boolean) {
		this.clientsService.setLeftSideBar(event)
	}

	returnCurrentTab(tab: string): number {
		switch (tab) {
			case 'details':
				return 1;	
			case 'plans':
				return 2;
			case 'users':
				return 3;	
			case 'activities':
				return 4;
			case 'templates':
				return 5;	
			case 'bucketCustomDomain':
				return 6;	
			default:
				return 1;
		}
	}

	openConfirmUpdateClientStatus(status: string) {
		this.selectedStatus = status;
		this.updateClientStatusModalRef = this.modalService.open(this.updateClientStatusModal, { size: 'l', backdrop: 'static', keyboard : false });
	}

	updateClientStatus() {
		this.submitted = true;
		this.spinner = true;

		this.clientsService.updateClientStatus(this.currentClientID, { status: this.selectedStatus }).subscribe({
			next: () => {
				this.submitted = false;
				this.spinner = false;
				this.success = true;
				const text = this.selectedStatus === 'ACTIVE' ? 'activated' : 'suspended';
				this.successMessage = 'The client has been ' + text  + ' successfully.';
				this.updateClientStatusModalRef.close();
				this.modalService.open(this.successModal, { size: 'l', backdrop: 'static', keyboard : false });
			},
			error: (err) => {
				this.submitted = false;
				this.spinner = false;
				this.success = false;
				
				const text = this.selectedStatus === 'ACTIVE' ? 'activated' : 'suspended';
				this.successMessage = 'The client could not have been ' + text  + '.';
				this.updateClientStatusModalRef.close();
				this.modalService.open(this.successModal, { size: 'l', backdrop: 'static', keyboard : false });
			}
		})
	}

	isSelected(val: string): boolean {
    if (!this.currentClient.client_extra?.report_templates) return false;
    return this.currentClient.client_extra.report_templates.some((t: any) => t.value === val);
  }

	toggleTemplateSelection(event: any, item: any): void {
    const isChecked = event.target.checked;
    
    if (!this.currentClient.client_extra) {
			this.currentClient.client_extra = {};
      this.currentClient.client_extra.report_templates = [];
    }

    if (isChecked) {
      // Add item if it's not already there
      const exists = this.currentClient.client_extra.report_templates.find((t: any) => t.value === item.value);
      if (!exists) {
        this.currentClient.client_extra.report_templates.push(item);
      }
    } else {
      // Remove item by filtering it out
      this.currentClient.client_extra.report_templates = this.currentClient.client_extra.report_templates.filter((t: any) => t.value !== item.value);
    }
  }

	updateClientBucketCustomDomain() {
		this.submitted = true;
		this.spinner = true;
		
		this.clientsService.updateClientBucketCustomDomain(this.currentClientID, {}).subscribe({
			next: () => {
				this.submitted = false;
				this.spinner = false;
				this.success = true;
				this.currentClient.bucket_custom_domain = !this.currentClient.bucket_custom_domain;
				this.authService.toastSuccessMessage('The client has been updated successfully.', 'Client Bucket Custom Domain');
			},
			error: (err) => {
				this.submitted = false;
				this.spinner = false;
				this.success = false;
				this.authService.toastErrorMessage('The client could not have been updated.', 'Client Bucket Custom Domain');
			}
		})
	}

	updateClientTemplates() {
		this.submitted = true;
		this.spinner = true;
		
		this.clientsService.updateClientTemplates(this.currentClientID, { templates: this.currentClient.client_extra.report_templates }).subscribe({
			next: () => {
				this.submitted = false;
				this.spinner = false;
				this.success = true;
				this.authService.toastSuccessMessage('The client has been updated successfully.', 'Client Templates');
			},
			error: (err) => {
				this.submitted = false;
				this.spinner = false;
				this.success = false;
				this.authService.toastErrorMessage('The client could not have been updated.', 'Client Templates');
			}
		})
	}

	changeTab(tabName: string) {
		if (tabName === 'details') {
			this.router.navigate([], {
				relativeTo: this.route,
				queryParams: { }
			});
		} else {
			this.router.navigate([], {
				relativeTo: this.route,
				queryParams: { tab: tabName },
				queryParamsHandling: 'merge'
			});
		}
	}

	setCurrentClient() {
		const clients = this.clientsService.getClientsList();
		const client = clients.find(client => client.id === this.currentClientID);

		if(client) {
			this.clientsService.setClient(client);
		} else {
			this.router.navigate(['clients']);
		}
	}

	async closeModal() {
		await this.clientsService.getClients();
		this.setCurrentClient();
		this.modalService.dismissAll();
	}
}
